import type { FunctionComponent } from "react"

import { clsx } from "clsx"

import styles from "./Stepper.module.css"

type StepperProps = {
  className?: string
  label: string
  step: 1 | 2
}

export const Stepper: FunctionComponent<StepperProps> = ({ className, label, step }) => {
  return (
    <div
      aria-label={label}
      aria-valuemax={2}
      aria-valuemin={1}
      aria-valuenow={step}
      className={clsx(styles.main, className)}
      role="progressbar"
    >
      {step === 1 && (
        <>
          <div className={clsx(styles.step, styles.firstStep, styles.currentStep)} />
          <div className={clsx(styles.step, styles.secondStep, styles.futureStep)} />
        </>
      )}

      {step === 2 && (
        <>
          <div className={clsx(styles.step, styles.firstStep, styles.completedStep)} />
          <div className={clsx(styles.step, styles.secondStep, styles.currentStep)} />
        </>
      )}
    </div>
  )
}
